/* eslint-disable sonarjs/no-duplicate-string */
import moment from 'moment';
import { Ticket, TicketContact, TicketContactRole, TicketPriority, TicketState, TicketType } from '../models/ticket.model';

const getDate = (date) => {
  return moment(date, 'MMM DD, YYYY, h:mm A').toDate();
};

const ticketContacts: Record<string, TicketContact> = {
  justUser: {
    id: '545',
    email: 'my@mail.com',
    firstName: 'John',
    lastName: 'Smith',
    date: getDate('Apr 13, 2025, 02:00 PM'),
    role: TicketContactRole.Contact
  },
  supportAgent: {
    id: '546',
    email: 'agent@mail.com',
    firstName: 'Alice',
    lastName: 'Brown',
    date: getDate('Apr 13, 2025, 02:15 PM'),
    role: TicketContactRole.Administrator
  },
  manager: {
    id: '547',
    email: 'manager@mail.com',
    firstName: 'Robert',
    lastName: 'Johnson',
    date: getDate('Apr 13, 2025, 03:00 PM'),
    role: TicketContactRole.Contact
  },
  technician: {
    id: '548',
    email: 'tech@mail.com',
    firstName: 'Emily',
    lastName: 'Davis',
    date: getDate('Apr 13, 2025, 03:45 PM'),
    role: TicketContactRole.Administrator
  }
};

export const tickets: Ticket[] = [
  {
    id: '5003',
    type: TicketType.Change,
    priority: TicketPriority.Low,
    assetId: '0bff0719-d61a-4de1-8366-22e6d75da000',
    asset: {
      name: 'Comp - 1'
    },
    companyId: 'c835291d-7c20-4b42-833d-9408c801f4d4',
    companyName: 'Company - 1',
    state: TicketState.Opened,
    title: 'john.doe47@tech.io',
    description: `The system experienced unexpected shutdowns. After diagnostics, we updated hardware components. The system is now stable and under observation.`,
    created: {
      id: 'de8f907a-0af6-4621-8a9f-eb1d58344985',
      email: 'john.doe47@tech.io',
      firstName: 'John',
      lastName: 'Doe47',
      date: getDate('Apr 13, 2025, 02:00 PM')
    },
    updated: {
      id: 'ffd60a74-782d-4d40-ab90-77447e52f778',
      email: 'editor@support.team',
      firstName: 'Editor',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 05:00 PM')
    },
    closed: {
      id: '98007663-0cd3-4089-beb8-7172f7fa95b3',
      email: 'resolver@support.team',
      firstName: 'Resolver',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 07:00 PM')
    },
    contact: ticketContacts.justUser,
    summary: { conversations: { total: 0 } }
  },
  {
    id: '5002',
    type: TicketType.Change,
    priority: TicketPriority.Medium,
    assetId: 'd07f1d83-5987-470d-9eb0-f0cb18479139',
    asset: {
      name: 'Comp - 2'
    },
    companyId: 'a9c79d36-7401-457c-b294-9487f7369895',
    companyName: 'Company - 2',
    state: TicketState.Closed,
    title: 'user48@tech.io',
    description: `The system experienced unexpected shutdowns. After diagnostics, we updated hardware components. The system is now stable and under observation.`,
    created: {
      id: '9c0e141b-560e-4106-b6ae-c28a2d145aae',
      email: 'user48@tech.io',
      firstName: 'User48',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 12:00 PM')
    },
    updated: {
      id: '05058310-be66-4d17-9c9f-b8bacbc298be',
      email: 'editor@support.team',
      firstName: 'Editor',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 05:00 PM')
    },
    closed: {
      id: 'f09c364d-4db5-4f15-8216-58d116069c7b',
      email: 'resolver@support.team',
      firstName: 'Resolver',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 07:00 PM')
    },
    contact: ticketContacts.supportAgent,
    summary: { conversations: { total: 0 } }
  },
  {
    id: '5001',
    type: TicketType.Change,
    priority: TicketPriority.High,
    assetId: 'e3b6a92d-7e64-4116-a37a-a021f192f29d',
    asset: {
      name: 'Comp - 3'
    },
    companyId: '712c24ee-1716-467f-ae4c-5905b1bcd8f1',
    companyName: 'Company - 3',
    state: TicketState.Closed,
    title: 'member49@yahoo.com',
    description: `The system experienced unexpected shutdowns. After diagnostics, we updated hardware components. The system is now stable and under observation.`,
    created: {
      id: 'e8e52872-bd61-4ef9-8238-7beb04644275',
      email: 'member49@yahoo.com',
      firstName: 'Member49',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 10:00 AM')
    },
    updated: {
      id: '4a2240f2-24d6-4014-a799-3f755839a1f2',
      email: 'editor@support.team',
      firstName: 'Editor',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 05:00 PM')
    },
    closed: {
      id: 'ef8bf194-3b4e-495f-bd85-b5fbfbd267a5',
      email: 'resolver@support.team',
      firstName: 'Resolver',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 07:00 PM')
    },
    contact: ticketContacts.manager,
    summary: { conversations: { total: 0 } }
  },
  {
    id: '5000',
    type: TicketType.Change,
    priority: TicketPriority.Critical,
    assetId: '12c24329-5ae2-45a9-8f20-0aad41e95044',
    asset: {
      name: 'Comp - 4'
    },
    companyId: 'c2d52e81-edff-4d3f-9a2a-6b9ae544abed',
    companyName: 'Company - 4',
    state: TicketState.Closed,
    title: 'client50@company.com',
    description: `The system experienced unexpected shutdowns. After diagnostics, we updated hardware components. The system is now stable and under observation.`,
    created: {
      id: '7a50876d-eff1-4fef-904a-de3c8e394c8e',
      email: 'client50@company.com',
      firstName: 'Client50',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 08:00 AM')
    },
    updated: {
      id: 'b926de81-dd41-419f-8749-ccaf87c32f92',
      email: 'editor@support.team',
      firstName: 'Editor',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 05:00 PM')
    },
    closed: {
      id: 'f9a1bd9e-d4d6-48c1-8053-9af8f6364ac5',
      email: 'resolver@support.team',
      firstName: 'Resolver',
      lastName: 'User',
      date: getDate('Apr 13, 2025, 07:00 PM')
    },
    contact: ticketContacts.technician,
    summary: { conversations: { total: 0 } }
  }
];
